import { cr } from "fire-wind-water";
import { $renderAdd, $renderUpdate } from "./render";
import { $cmsData } from "../common/setting";

export function $renderTemplate(res) {
  const c = document.getElementById("sk-cms-main");
  if (cr.isEmptyObject(res)) {
    if (c) {
      c.innerHTML = "";
    }
  }
  cr.each(res, (o, d) => {
    let str = "";
    const dom = document.getElementById(d) || c;
    o.sort((a, b) => {
      return a.historyOrderId - b.historyOrderId;
    });
    cr.each(o, (m) => {
      str += $renderAdd(
        m.type,
        m.category,
        cr.isPlainObject(m.historyContent) ? m.historyContent : m.content
      );
    });
    if (dom) {
      dom.innerHTML = str;
    }
  });
}

export function $renderComponent(data, category) {
  const result = $renderUpdate(category, data);
  if (!result.dom) {
    $renderTemplate($cmsData.container);
  } else {
    result.dom.innerHTML = result.html;
  }
}
